import { Image, Alert, Button, Badge, Card, CardColors, Text } from '@/ui'
import {
  createUpriseAccount,
  FinancialAdvisoryProfile,
  FinancialAdvisoryProfilesStatus,
  putFinancialAdvisoryProfile,
} from '../financialAdvisory.slice'
import { useEffect, useState } from 'react'
import { track } from '@amplitude/analytics-browser'
import { useAnalyticsView } from '@/features/amplitude'
import { useAppDispatch } from '@/utils/typeHelpers'
import { UpriseIntroCard } from './IntroCallCTAPanel'
import { TypographyStyles } from '@/styles'

export const PostPaymentPanel = ({
  faProfile,
}: {
  faProfile: FinancialAdvisoryProfile
}) => {
  const dispatch = useAppDispatch()
  const pageView = useAnalyticsView()
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const submitUpriseOnboarding = async () => {
    setLoading(true)
    setError('')
    try {
      track('started uprise onboarding — post purchase', {
        fa_profile_id: faProfile.id,
        user_id: faProfile.userId,
      })
      const response = await createUpriseAccount()(dispatch)
      await putFinancialAdvisoryProfile(faProfile.id, {
        status: FinancialAdvisoryProfilesStatus.onboarding,
      })(dispatch)
      if (!response) {
        setError('Something went wrong! Please refresh and try again.')
      }
    } catch {
      setError('An unexpected error occurred. Please try again later.')
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    pageView('advisory: post payment panel')
  }, [pageView])

  return (
    <>
      {error && (
        <Alert
          variant="error"
          description="It looks like we encountered an error while trying to onboard you! Please try again."
        />
      )}

      {faProfile.subscriptionStatus === 'paid' && (
        <Alert
          variant="default"
          description="Thank you for purchasing the Advisory Add On!"
        />
      )}

      <Card color={CardColors.LEVEL_1}>
        <div className="flex flex-col lg:flex-row gap-8 px-4 py-6">
          <div className="w-full lg:w-2/3 space-y-4">
            <Badge color="orange">Almost There</Badge>
            <Text variant={TypographyStyles.H1}>
              Onboard to receive your 100% personalized financial plan
            </Text>
            <Text variant={TypographyStyles.BODY_MD}>
              We are so excited to support you with your financial goals!
            </Text>
            <Text variant={TypographyStyles.BODY_MD}>
              Your next step is to onboard and share additional details of your
              financial situation. This includes information about your personal
              financial goals and additional color around your holistic
              financial picture (assets, personal accounts, investments etc.),
              which would enable your advisor to build a comprehensive plan.
            </Text>
            <Button
              variant="primary"
              loading={loading}
              onClick={() => submitUpriseOnboarding()}
            >
              Start Onboarding
            </Button>
          </div>
          <Image
            className="w-full lg:w-1/3 flex justify-center items-center"
            src="https://heard-images.s3.amazonaws.com/assets/advisory_screen.svg"
            alt="heard financial advisory"
          />
        </div>
      </Card>

      <div className="my-6">
        <UpriseIntroCard />
      </div>
    </>
  )
}
